import React from 'react';
//Components
import Sidebar from './../../components/Sidebar';

export default function DesktopView({ items }) {
  return <Sidebar items={items} />;
}
